import axiosCustom from '../axiosApi';
import axios from "axios";
import {
    FETCH_SERVICE_ORDER_DETAIL,
    RECEIVE_SERVICE_ORDER_DETAIL,
    RECEIVE_SERVICE_ORDER_PROCESS_DETAIL,
    FETCH_SERVICE_ORDER_PROCESS_DETAIL,
    RECEIVE_SERVICE_ORDER_SERVICE_DETAIL,
    FETCH_SERVICE_ORDER_SERVICE_DETAIL,
    FETCH_FOTOGRAFIA_PLANTA,
    RECEIVE_FOTOGRAFIA_PLANTA,
    FETCH_ESTATISTICA_ETAPA,
    RECEIVE_ESTATISTICA_ETAPA,
    FETCH_OS_TIPO_PERGUNTA,
    RECEIVE_OS_TIPO_PERGUNTA,
    FETCH_OS_ESTATISTICA_COLA_VERDE,
    RECEIVE_OS_ESTATISTICA_COLA_VERDE,
    RECEIVE_OPERADORES_ESTATISTICAS,
    FETCH_OPERADORES_ESTATISTICAS,
    FETCH_DIARIO_PRODUCAO,
    RECEIVE_DIARIO_PRODUCAO,
    FETCH_TEMPO_ETAPAS,
    RECEIVE_TEMPO_ETAPAS,
    FETCH_ACOMPANHAMENTO_OS,
    RECEIVE_ACOMPANHAMENTO_OS,
    FETCH_OS_RECEBIDOS_FINALIZADOS,
    RECEIVE_OS_RECEBIDOS_FINALIZADOS,
    FETCH_LISTA_OS_HEADER,
    RECEIVE_LISTA_OS_HEADER,
    FETCH_ORDENS_PARA_CORTE,
    RECEIVE_ORDENS_PARA_CORTE,
    FETCH_OS_MOVIMENTADAS_PERIODO_DETALHADO,
    RECEIVE_OS_MOVIMENTADAS_PERIODO_DETALHADO,
    FETCH_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2, RECEIVE_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2
} from './actionTypes'
import {useSelector} from "react-redux";


export const fetchServiceOrderDetail =  () => ({
    type: FETCH_SERVICE_ORDER_DETAIL
});

export const fetchServiceOrderProcessDetail =  () => ({
    type: FETCH_SERVICE_ORDER_PROCESS_DETAIL
});

export const fetchServiceOrderServiceDetail =  () => ({
    type: FETCH_SERVICE_ORDER_SERVICE_DETAIL
});

export const receiveServiceOrderDetail = payload => ({
    type: RECEIVE_SERVICE_ORDER_DETAIL,
    payload: payload
})

export const receiveServiceOrderProcessDetail = payload => ({
    type: RECEIVE_SERVICE_ORDER_PROCESS_DETAIL,
    payload: payload
})

export const receiveServiceOrdeServiceDetail = payload => ({
    type: RECEIVE_SERVICE_ORDER_SERVICE_DETAIL,
    payload: payload
});

export const fetchFotografiaPlanta =  () => ({
    type: FETCH_FOTOGRAFIA_PLANTA
});

export const receiveFotografiaPlanta = payload => ({
    type: RECEIVE_FOTOGRAFIA_PLANTA,
    payload: payload
});


export const fetchOrdensParaCorte =  () => ({
    type: FETCH_ORDENS_PARA_CORTE
});

export const receiveOrdensParaCorte = payload => {
    return ({
        type: RECEIVE_ORDENS_PARA_CORTE,
        payload: payload
    });
};


export const fetchEstatisticaEtapa =  (etapa) => ({
    type: FETCH_ESTATISTICA_ETAPA,
    payload: {
        etapa: etapa
    }
});

export const receiveEstatisticaEtapa = payload => ({
    type: RECEIVE_ESTATISTICA_ETAPA,
    payload: payload
});

export const fetchOSPorTipoPergunta =  () => ({
    type: FETCH_OS_TIPO_PERGUNTA
});

export const receiveOSPorTipoPergunta = payload => ({
    type: RECEIVE_OS_TIPO_PERGUNTA,
    payload: payload
});

export const fetchOSEstatisticaColaVerde =  () => ({
    type: FETCH_OS_ESTATISTICA_COLA_VERDE
});

export const receiveOSEstatisticaColaVerde = payload => ({
    type: RECEIVE_OS_ESTATISTICA_COLA_VERDE,
    payload: payload
});

export const fetchOSEEstatisticasPorOperador =  () => ({
    type: FETCH_OPERADORES_ESTATISTICAS
});

export const receiveOSEEstatisticasPorOperador = payload => ({
    type: RECEIVE_OPERADORES_ESTATISTICAS,
    payload: payload
});

export const fetchDiarioProducao =  () => ({
    type: FETCH_DIARIO_PRODUCAO
});

export const receiveDiarioProducao = payload => ({
    type: RECEIVE_DIARIO_PRODUCAO,
    payload: payload
});

export const fetchAcompanhamentoOS =  () => ({
    type: FETCH_ACOMPANHAMENTO_OS
});

export const receiveAcompanhamentoOS =  (payload) => ({
    type: RECEIVE_ACOMPANHAMENTO_OS,
    payload: payload
});

export const fetchTempoEtapas =  () => ({
    type: FETCH_TEMPO_ETAPAS
});

export const receiveTempoEtapas = payload => ({
    type: RECEIVE_TEMPO_ETAPAS,
    payload: payload
});

export const fetchListaOSHeader =  () => ({
    type: FETCH_LISTA_OS_HEADER
});

export const receiveListaOSHeader = payload => ({
    type: RECEIVE_LISTA_OS_HEADER,
    payload: payload
});


export const fetchRecebidosFinalizados =  () => ({
    type: FETCH_OS_RECEBIDOS_FINALIZADOS
});

export const receiveRecebidosFinalizados = payload => ({
    type: RECEIVE_OS_RECEBIDOS_FINALIZADOS,
    payload: payload
});

export const fetchOSMovimentadasDetalhado =  () => ({
    type: FETCH_OS_MOVIMENTADAS_PERIODO_DETALHADO
});
export const receiveOSMovimentadasDetalhado = payload => ({
    type: RECEIVE_OS_MOVIMENTADAS_PERIODO_DETALHADO,
    payload: payload
});


export const fetchOSMovimentadasDetalhadoV2 =  () => ({
    type: FETCH_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2
});
export const receiveOSMovimentadasDetalhadoV2 = payload => ({
    type: RECEIVE_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2,
    payload: payload
});


export const getServiceOrderDetail = (serviceOrderId) => {
    return async (dispatch, getState) => {
        dispatch(fetchServiceOrderDetail());
        let payload;
        try {
        //
            const estabelecimento =  getState().filter.estabelecimentoId;

            console.log("GETSERVICEORDERDETAIL", serviceOrderId);

            //let url = `/ordem-servicos/OS/${estabelecimento}/${serviceOrderId}?filter={  "include": [ {"relation": "cliente" }, {"relation": "statusOrdemServico" }, { "relation" : "pneuModelo", "scope": {  "include":[ { "relation": "pneuFabricante" } ]  }    } , { "relation" : "pneuMedida"  } ,  { "relation": "banda"  },  { "relation": "itemBandaAplicada"  },  { "relation":  "processo" , "scope": {"include":[{"relation":"processoEtapas"}]}},{"relation":"ordemServicoEtapas", "order": [ "DTInicioProducao ASC" ],  "scope":{"include":[{"relation": "estacaoTrabalho"},{"relation": "operador"},{ "relation": "processoEtapa"},{"relation":"ordemServicoEtapaQuestaos", "scope":{ "include":[ { "relation": "processoEtapaQuestao" } ]  }   }   ]   }}]}`;
            let url = `/ordem-servicos/OSCompleto/${estabelecimento}/${serviceOrderId}`;
            console.log("url", url);
            const response = await axiosCustom.get(url)

            let url2 = `/raspa-ciclos?filter={ "where":{ "ordemServico" : "${serviceOrderId}" } }`
            console.log("url2", url2);
            const response2 = await axiosCustom.get(url2);
            console.log("Raspa RESPONSE ", response2);

            let url3 = `/roitread-ciclos?filter={ "where":{ "ordemServico" : "${serviceOrderId}" } }`
            console.log("url3", url3);
            const response3 = await axiosCustom.get(url3);
            console.log("ROITREAD RESPONSE ", response3);

           // debugger;
            if (response.data && response.data.ordemServicoEtapas) {
                let p = response.data;

                //adiciona ciclo da raspa
                const peix = p.ordemServicoEtapas.findIndex(e => e.processoEtapa.etapaId === 7);

                if (peix >= 0 && response2.data.length > 0) {
                    let e = {
                        ...p.ordemServicoEtapas[peix],
                        raspaCiclos: response2.data,

                    };
                    p.ordemServicoEtapas[peix] = e;
                }

                //adiciona ciclo da roitread
                const perolix = p.ordemServicoEtapas.findIndex(e => e.processoEtapa.etapaId === 18);

                if (perolix >= 0 && response3.data.length > 0) {
                    let e = {
                        ...p.ordemServicoEtapas[perolix],
                        roitreadCiclos: response3.data,

                    };
                    p.ordemServicoEtapas[perolix] = e;
                }



                payload = p; //response.data
                console.log("********** p *********", p);
            }
            else {
                payload = response.data;
            }



        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
        }
        finally {
            dispatch(receiveServiceOrderDetail(payload));
        }
    }
}

export const getServiceOrderProcessDetail = (processId) => {
    return async dispatch => {
        dispatch(fetchServiceOrderProcessDetail());
        let payload;
        try {
            const response = await axiosCustom.get(`/ProcessSteps?filter={ "where": { "processId": ${processId}, "Type": 4 } }`)
            payload = response.data && response.data.length ? response.data[0] : response.data
            // payload = 11;
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
          // payload = 11;
            dispatch(receiveServiceOrderProcessDetail(payload));
        }
    }
}

export const getServiceOrderServiceDetail = (id, processStepId) => {
    return async dispatch => {
        dispatch(fetchServiceOrderServiceDetail());
        let payload;
        try {
            const response = await axiosCustom.get(`/ServiceOrderSteps?filter={ "where": { "serviceOrderId": ${id}, "processStepId": ${processStepId} } }`)
            payload = response.data
        }
        catch(e) {
            payload = {error: true};
        }
        finally {
            dispatch(receiveServiceOrdeServiceDetail(payload));
        }
    }
}

export const updateAnswers = ( serviceOrderId, questions ) => {
  return async (dispatch, getState) => {
    dispatch(fetchServiceOrderDetail());
    try {
      await axiosCustom.put("/SOStepQuestions/updateAnswers", questions)
    }
    catch(e) {
      // const payload = { error: true };
    }
    finally {
      dispatch(getServiceOrderDetail(serviceOrderId));
    }
  }
}

export const getFotografiaPlanta = () => {


    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            console.log("getFotografia Mock");
            return;
        }

        dispatch(fetchFotografiaPlanta());
        console.log("getFotografias");
        let payload;
        try {



            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')
            const response = await axiosCustom.get(`/ordem-servicos/os-por-etapa`);

            const url2 = `/ordem-servicos/concluidas-por-etapa?intervalo={"min": "${min}" ,"max": "${da.toISOString()}"}`;
            const response2 = await axiosCustom.get(url2)
            payload =  {
                situacaoAtual: response.data,
                qtdeConcluidasPorEtapa: response2.data
            }
            console.log("getFoto payload",payload);
        }
        catch(e) {
            payload = { error: true, message: e };
        }
        finally {
            dispatch(receiveFotografiaPlanta(payload));
        }
    }
}

export const getRecebidosFinalizadosOS = () => {
    return async (dispatch,getState) => {
        dispatch(fetchRecebidosFinalizados());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;
            const url2 = `/ordem-servicos/recebidos-finalizados-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axiosCustom.get(url2)
            payload =  {
                recebidosFinalizados: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
        }
        finally {
            dispatch(receiveRecebidosFinalizados(payload));
        }
    }
}

export const getEstatisticaEtapa = (etapa) => {
    return async (dispatch, getState) => {
        dispatch(fetchEstatisticaEtapa(etapa));
        let payload;
        try {


            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

                // let options1 = {
                //     "Interval": {
                //         "Min": periodMin,
                //         "Max": periodMax
                //     },
                //     "IntervalComparasion": {
                //         "Min": beforeperiodMin,
                //         "Max": beforeperiodMax
                //     },
                //     "IntervalBenchmark": {
                //         "Min": benchperiodMin,
                //         "Max": benchperiodMax
                //     }
                // }


            let url = `/ordem-servicos/os-da-etapa?intervalo={"min":"${periodMin}","max":"${periodMax}"}&etapa=${etapa} `;
            const response = await axiosCustom.get(url)

            let url2 = `/ordem-servico-etapas/distribuicaoDataHora?intervalo={"min":"${periodMin}","max":"${periodMax}"}&etapaId=${etapa}`;
            console.log("URL", url2)

            const response2 = await axiosCustom.get(url2)

            payload =  {
                etapa: etapa,
                data: {
                    totais: response.data,
                    distribuicaoDataHora: response2.data
                }
            }
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            // payload = 11;
            dispatch(receiveEstatisticaEtapa(payload));
        }
    }
}

export const getOSContagemPorTipoPergunta = (tipoPergunta) => {
    return async (dispatch, getState) => {
        dispatch(fetchOSPorTipoPergunta());
        let payload;
        try {

            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

            let url = `/ordem-servicos/os-contagem-por-tipo-pergunta?intervalo={"min":"${periodMin}","max":"${periodMax}"}&tipoPergunta=${tipoPergunta}`;
            // console.log("URL tipoPergunta", url)


            const response = await axiosCustom.get(url);
           // console.log("pergunta response", response.data);
            const xp = (response.data && response.data.length>0)?  response.data[0].pergunta : '';
            payload =  {
                data: {
                    pergunta: xp,
                    tipoPergunta: tipoPergunta,
                    contagem: response.data
                }
            }
        }
        catch(e) {
            console.log('ERROR getOSContagemPorTipoPergunta catch error ', e);
            payload = { error: true };
        }
        finally {
            // payload = 11;
            dispatch(receiveOSPorTipoPergunta(payload));
        }
    }
}

export const getEstatisticasOSCalculoColaVerde = () => {
    return async (dispatch, getState) => {
        dispatch(fetchOSEstatisticaColaVerde());
        let payload;
        try {

            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

            let url = `/ordem-servicos/os-calculo-cola-verde?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            // console.log("URL", url)

            const response = await axiosCustom.get(url)
            payload =  {
                data: {

                    colaVerde: response.data
                }
            }
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            // payload = 11;
            dispatch(receiveOSEstatisticaColaVerde(payload));
        }
    }
}

export const getOSEEstatisticasPorOperador = () => {
    return async (dispatch, getState) => {
        const bMock = getState().i4.mock;
        if (bMock) {

            return;
        }

        dispatch(fetchOSEEstatisticasPorOperador());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate();

            const { periodMin, periodMax } = getState().filter;

            let url = `/ordem-servico-etapas/estatisticaOperadorPorHoraDoDia?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
             console.log("URL", url)

            const response = await axiosCustom.get(url)

            console.log("resposta estatisticaOperadorPorHora", response.data);

            payload =  {
                data: {

                    estatisticaOperadorPorHoraDia: response.data
                }
            }
        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            dispatch(receiveOSEEstatisticasPorOperador(payload));
        }
    }
}

export const getOSMovimentadasDetalhado = () => {
    return async (dispatch, getState) => {
        dispatch(fetchOSMovimentadasDetalhado());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate();

            const { periodMin, periodMax } = getState().filter;

            let url = `/ordem-servicos/movimentadas-periodo-detalhado?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log("URL", url)

            const response = await axiosCustom.get(url)

            console.log("resposta OSMovimentadasPeriodoDetalhado", response.data, JSON.stringify(response.data).length);

            payload =  {
                data: {
                    movimentadasPeriodoDetalhada: response.data
                }
            }

            console.log("getOSMovimentadasDetalhado size", response.data.length);

        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            dispatch(receiveOSMovimentadasDetalhado(payload));
        }
    }
}


export const getOSMovimentadasDetalhadoV2 = () => {
    return async (dispatch, getState) => {
        if (getState().filter.estabelecimentoId > 90) { return; }
        dispatch(fetchOSMovimentadasDetalhadoV2());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate();

            const { periodMin, periodMax } = getState().filter;

            let url = `/ordem-servicos/movimentadas-periodo-detalhadov2?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log("URL", url)

            const response = await axiosCustom.get(url)

            console.log("resposta OSMovimentadasPeriodoDetalhadoV2", response.data, JSON.stringify(response.data).length);

            payload =  {
                data: {
                    os: response.data,
                    periodoIni: periodMin,
                    periodoFim: periodMax
                }
            }

            console.log("getOSMovimentadasDetalhado size", response.data.length);

        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            dispatch(receiveOSMovimentadasDetalhadoV2(payload));
        }
    }
}


export const getDiarioProducao = () => {
    return async (dispatch, getState) => {
        dispatch(fetchDiarioProducao());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0');

            const { periodMin, periodMax } = getState().filter;
            console.log("getDiarioProducao periodos", periodMin, periodMax);
            const pmin = new Date(periodMin);
            const pmax = new Date(periodMax);
            const dif = pmax - pmin;
            const oneDay = 1000 * 60 * 60 * 24;
            if (Math.round(dif/oneDay) > 1) {
                console.log("INTERVALO DE DATAS DEVE SER APENAS DE 1 DIA", Math.round(dif/oneDay));
                payload =  {
                    data: {

                        diarioProducao: []
                    }
                }
                dispatch(receiveDiarioProducao(payload));
                return;
            }

            const url = `/ordem-servico-etapas?filter={ "where": { "DTInicioProducao":  { "between": ["${periodMin}","${periodMax}"] } }, "order": [ "os"  ] ,
                "include": [ { "relation": "operador" }, { "relation": "ordemServicoEtapaQuestaos",  "scope": { "include": [ { "relation": "processoEtapaQuestao" }] }   }, { "relation" : "processoEtapa", "scope": {  "include":[ { "relation": "etapa" }, { "relation": "processoEtapaQuestoes" } ]  }    }, 
               { "relation": "ordemServico" , "scope": { "include": [ { "relation": "banda" }, {  "relation": "cliente" }, {"relation": "pneuModelo" , "scope": {  "include": [  {  "relation": "pneuFabricante"  }  ]  }  }   ] } } , { "relation": "estacaoTrabalho"  }, { "relation": "operador"  }  ]  }`;


            console.log(url);

            const response = await axiosCustom.get(url)

           // console.log("resposta getDiarioProducao", response.data);

            payload =  {
                data: {

                    diarioProducao: response.data
                }
            }
        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            dispatch(receiveDiarioProducao(payload));
        }
    }
}

export const getListaOSheaders = () => {
    return async (dispatch, getState) => {
        dispatch(fetchListaOSHeader());
        let payload;
        try {

            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

                   let url = `/ordem-servicos/lista-os-header?intervalo={"min":"${periodMin}","max":"${periodMax}"} `;
            const response = await axiosCustom.get(url);
            console.log("response payload", response)

            payload =  {
                data: {
                    listaOSHeader: response.data
                }
            }
            console.log("response payload", response, payload)
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            // payload = 11;
            dispatch(receiveListaOSHeader(payload));
        }
    }
}

export const getAcompanhamentoOS = () => {
    return async (dispatch, getState) => {
        dispatch(fetchAcompanhamentoOS());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0');

            const { periodMin, periodMax, estabelecimentoId } = getState().filter;
            console.log("getDiarioProducao periodos", periodMin, periodMax);


            const url = `/ordem-servicos?filter=
{
    "where": { 
       "DTInicioProducao":  { "between": ["${periodMin}","${periodMax}"], "estabelecimentoId": ${estabelecimentoId} } 
\t},
\t"order": [ "ordemServicoId"  ] ,  
\t"include": [  
                 { "relation" : "pneuModelo", "scope": {  "include":[ { "relation": "pneuFabricante" } ]  }    },
                 {"relation": "banda"},
                 {"relation": "cliente"},
\t\t\t\t {"relation":"ordemServicoEtapas", 
\t\t\t\t   "order": [ "DTChegada ASC" ],  
\t\t\t\t   "scope":{
\t\t\t\t         "include":[
\t\t\t\t\t\t     {"relation": "estacaoTrabalho"},
\t\t\t\t\t\t\t {"relation": "operador"},
\t\t\t\t\t\t\t { "relation": "processoEtapa"},
\t\t\t\t\t\t\t {"relation":"ordemServicoEtapaQuestaos", 
\t\t\t\t\t\t\t      "scope":{ 
\t\t\t\t\t\t\t\t       "include":[ { "relation": "processoEtapaQuestao" } ]  
\t\t\t\t\t\t\t\t\t}   
\t\t\t\t\t\t\t }
\t\t\t\t\t\t  ]
\t\t\t\t   }
\t\t\t\t}
\t]
}`;


            console.log(url);

            const response = await axiosCustom.get(url)


            // console.log("resposta getDiarioProducao", response.data);

            const payload =  {
                data: {

                    acompanhamentoOS: response.data
                }
            }
        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            dispatch(receiveAcompanhamentoOS(payload));
        }
    }
}

export const getTempoEtapas = () => {
    return async (dispatch, getState) => {

            const bMock = getState().i4.mock;
            if (bMock) {
                return;
            }


        dispatch(fetchTempoEtapas());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0');

            const { periodMin, periodMax } = getState().filter;

            console.log("getTempoEtapas", periodMin, periodMax);

            const url = `/ordem-servico-etapas/temposPorMedida?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axiosCustom.get(url)

            console.log("resposta getTempoEtapas", response.data);

            payload =  {
                data: {

                    tempoEtapas: response.data
                }
            }
        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            dispatch(receiveTempoEtapas(payload));
        }
    }
}

export const getImportOSTenant = (ordemServico, prioridade)=> {
    return async (dispatch, getState) => {

        console.log("getImportOSTenant",ordemServico)
       // dispatch(fetchTempoEtapas());
        let payload;
        try {

            const url = `/erp-ordem-servicos/importar-de-tenant?os=${ordemServico}&prioridade=${prioridade}`;
            console.log(url);
            const response = await axiosCustom.get(url);

            payload =  response.data;
        }
        catch(e) {
            console.log("try catch",e);
            payload = { error: true };
        }
        finally {
            //dispatch(receiveTempoEtapas(payload));
        }
    }
}

export const getOrdensParaCorte = () => {
    return async (dispatch, getState) => {
        console.log("getOrdensParaCorte dispatch iniciado");
        dispatch(fetchOrdensParaCorte());
        let payload;
        try {

            let url = `/ordem-servicos/ordens-para-corte`;
            const response = await axiosCustom.get(url);

            //console.log("resposta ordens para corte", response.data);

            payload =  {
                data: {

                    ordensParaCorte: response.data
                }
            }
        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            console.log("getOrdensParaCorte dispatch receive");
            dispatch(receiveOrdensParaCorte(payload));
        }
    }
}

export  const postCorteRespostas = ( ordemServico, codbarBanda, bandaId,  codbarNSBanda, codValidacao, dtIni, dtFim, loteLigacao, ligacao) => {
    return async (dispatch, getState) => {

        console.log("postCorteRespostas loteLigacao", loteLigacao);

        let payload;
        try {

            let url = `/ordem-servico-etapas/corte-banda`;
            const data = {
                os : ordemServico.os,
                osId: ordemServico.osId,
                oseId: ordemServico.oseId,
                bandaId: bandaId,
                codbarBanda: codbarBanda,
                codbarNSBanda: codbarNSBanda,
                codLigacao: ligacao,
                loteLigacao: loteLigacao,
                dtCorte: new Date().toISOString(),
                codValidacao: codValidacao,
                DTInicioProducao: dtIni,
                DTFimProducao: dtFim
            }
            console.log("POST CorteBanda parametros", data);


            const response = await axiosCustom.post(url, data);
            payload =  response.data;


        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
           // dispatch(receivePostCorteRespostas(payload));
            console.log("POST action dispatch getOrdensParaCorte");
            dispatch(getOrdensParaCorte);
        }
    }
}


export  const postCortePrintEtiqueta = ( ordemServico, codValidacao) => {
    return async (dispatch, getState) => {



        let payload;
        try {
            const data = {
                os : ordemServico.os,
                banda: ordemServico.banda,
                largura: ordemServico.largura,
                comprimento: ordemServico.comprimento,
                validacao: codValidacao
            }

            const url = `http://127.0.0.1:5010/zebra/corte?os=${ordemServico.os}&&banda=${ordemServico.banda}&&largura=${ordemServico.largura}&&comprimento=${ordemServico.perimetro}&&`+
                                  `validacao=${ordemServico.validacao}&&fabricante=${ordemServico.fabricante}&&modelo=${ordemServico.modelo}&&fogo=${ordemServico.marcaFogo}&&dot=${ordemServico.dot}&&modeloEtiqueta=2`;

            console.log(url);

            const resp  = axios.get(url);
            payload = resp.data;

        }
        catch(e) {
            console.log("try postCortePrintEtiqueta catch",e)
            payload = { error: true };
        }

    }
}


export  const getUrlGet = ( strGet) => {
    return async (dispatch, getState) => {



        let payload;
        try {

           // const url = `http://127.0.0.1:5010/zebra/corte?os=${ordemServico.os}&&banda=${ordemServico.banda}&&largura=${ordemServico.largura}&&comprimento=${ordemServico.perimetro}&&`+
           //     `validacao=${ordemServico.validacao}&&fabricante=${ordemServico.fabricante}&&modelo=${ordemServico.modelo}&&fogo=${ordemServico.marcaFogo}&&dot=${ordemServico.dot}&&modeloEtiqueta=2`;

            console.log(strGet);

            const resp  = axios.get(strGet);
            payload = resp.data;
            console.log('payload', payload);

        }
        catch(e) {
            console.log("try getUrlGet catch",e)
            payload = { error: true };
        }

    }
}



export  const postOSHeader = ( dados) => {
    return async (dispatch, getState) => {


        let payload;
        let response;
        try {

            let url = `/ordem-servicos/cabecalho`;
            console.log("POST OSHeader parametros", dados);

            response = await axiosCustom.post(url, dados);

            payload =  response.data;
        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            // dispatch(receivePostCorteRespostas(payload));
            console.log("POST action dispatch getOrdensParaCorte", response.data);
           // dispatch(getOrdensParaCorte);
            //dispatch(getServiceOrderDetail(dados.ordemServicoId));
            if (response.data.ordemServicoId) {
                dispatch(getServiceOrderDetail(response.data.ordemServicoId));
            } else {
                dispatch(getServiceOrderDetail(dados.ordemServicoId));
            }
        }
    }
}

export  const patchOSE = ( id,dados) => {
    return async (dispatch, getState) => {


        let payload;
        let response;
        try {

            let url = `/ordem-servico-etapas/${id}`;
            console.log("POST patchOSE parametros", dados);

            response = await axiosCustom.patch(url, dados);

            payload =  response.data;
        }
        catch(e) {
            console.log("try catch",e)
            payload = { error: true };
        }
        finally {
            // dispatch(receivePostCorteRespostas(payload));
            console.log("POST patchOSE", response.data);
            // dispatch(getOrdensParaCorte);
            //dispatch(getServiceOrderDetail(dados.ordemServicoId));

        }
    }
}






